import { connect } from "react-redux";
import CreditRow from "./CreditRow";
import { Actions as COMPANY_ACTIONS } from "../../../store/actions/companyActions";
import { useMemo } from "react";
import { TrashIcon } from "@/icons/solid";
import TransferCreditToAdvisorModal from "@/components/company-settings/billing-tab/TransferCreditToAdvisorModal";

const CreditHistory = ({ bills, payPeriodDetails, setBillingModal, hasSelectedCredits, isAdmin }) => {
	const hasPendingBills = useMemo(() => {
		if (bills) {
			return bills.filter((bill) => bill.billingStatus === "Pending").length > 0;
		}
	}, [bills]);

	return (
		<>
			{isAdmin && <TransferCreditToAdvisorModal />}
			<div className="content bg-white">
				<div className="clearfix" />
				<div className="block-header">
					<h3 className="block-title">Credit History</h3>
					{isAdmin ? (
						<button
							className="btn btn-default pull-right"
							type="button"
							style={{ marginRight: 5 }}
							onClick={() => setBillingModal("VoidAdvisorCredits")}
							disabled={!hasPendingBills || !hasSelectedCredits}
						>
							<TrashIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
							<div style={{ float: "left" }}>Void Transactions</div>
						</button>
					) : null}
				</div>
				<div className="block-content">
					<div style={{ overflow: "scroll" }}>
						<table className="table table-responsive">
							<thead>
								<tr>
									<th width="5%"></th>
									<th>Date</th>
									<th>Transaction</th>
									<th>Balance</th>
									<th>Details</th>
								</tr>
							</thead>
							<tbody>
								{bills &&
									bills.map((bill) => {
										const periodDetails =
											payPeriodDetails &&
											payPeriodDetails.filter((item) => item.payPeriodId == bill.payPeriod);
										return (
											<CreditRow
												key={bill.id}
												credit={bill}
												payPeriodDetails={periodDetails}
												invoiceNo={bill.invoiceNo}
												creditId={bill.id}
												hasPendingBills={hasPendingBills}
											/>
										);
									})}
							</tbody>
							<tfoot>
								<tr>
									<th colSpan={4}>
										Showing 1-{bills.length} of {bills.length}
									</th>
									{/* <th style={{ textAlign: "right" }}>
										&lt; 1 &gt;
									</th> */}
								</tr>
							</tfoot>
						</table>
					</div>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		isAdmin: state?.my?.profile?.isAdmin,
		bills: state.advisor?.credits || [],
		payPeriodDetails: state.payPeriods && state.payPeriods.periods,
		hasSelectedCredits: state.advisor?.hasSelectedCredits,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setBillingModal: (billingModal) => dispatch(COMPANY_ACTIONS.setBillingModal(billingModal)),

});

export default connect(mapStateToProps, mapDispatchToProps)(CreditHistory);
